import { Dimension } from '../../../../models/monitoring-dimension';
import { LatestNotification } from '../../models/common.model';
import { MonitoringStatus, StatusAcceptanceType } from '../../../../constants';
import { DeliveryNoteTypeView } from '../constants/automotive-aftermarket-list.constant';
import { ListViewMode } from '../../constants';

export const AutomotiveAftermarketTypeView: Record<
  keyof typeof ListViewMode | keyof typeof DeliveryNoteTypeView,
  ListViewMode | DeliveryNoteTypeView
> = {
  ...ListViewMode,
  ...DeliveryNoteTypeView,
};

export type AutomotiveAftermarketTypeViewType = ListViewMode | DeliveryNoteTypeView;

export interface CurrentStatus {
  id: number;
  statusCode: string;
  shipToAddress: string;
  actualArrivalTime: number;
  acceptanceType: StatusAcceptanceType;
  statusDescription: string;
  reasonCode: string;
  reasonCodeDescription: string;
  current: boolean;
}

export class DeliveryNote {
  deliveryNoteNumber: string;
  extNumber: string;
  latestNotification: LatestNotification;
  currentStatus: CurrentStatus;
  sapId: string;
  status: MonitoringStatus;
  plannedTimeArrivalDate: number;
  routeId: string;
  equipmentId: string;
  transportNumber: string;
  carrierId: string;
  carrierName: string;
  carrierTrackingNumber: string;
  shipperExtId: string;
  shipperName: string;
  shipperAddress: string;
  pickUpExtId: string;
  pickUpName: string;
  pickUpAddress: string;
  shipToExtId: string;
  shipToName: string;
  shipToAddress: string;
  soldToExtId: string;
  soldToName: string;
  soldToAddress: string;
  actualGoodsIssueDate: number;

  constructor(params?: DeliveryNote) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DeliveryNotePrimary extends DeliveryNote {
  handlingUnits: HandlingUnitSecondary[];

  constructor(params?: DeliveryNotePrimary) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class HandlingUnitPrimary {
  huId: string;
  latestNotification: LatestNotification;
  currentStatus: CurrentStatus;
  status: MonitoringStatus;
  ptaDate: number;
  actualGoodsIssueDate: number;
  dnLspForwarderName: string;
  dnLspTrackingNumber: string;
  dnTransportNumber: string;
  dnRouteId: string;
  dnEquipmentId: string;
  width: Dimension;
  height: Dimension;
  length: Dimension;
  weight: Dimension;
  volume: Dimension;
  deliveryNote: DeliveryNote;

  constructor(params?: HandlingUnitPrimary) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface HandlingUnitSecondary {
  huId: string;
  latestNotification: LatestNotification;
  packagingType: string;
  weightDimension: Dimension;
  status: MonitoringStatus;
  currentStatus: CurrentStatus;
}
